var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"bigBody"},[_c('div',{staticClass:"smallBody",style:('width:' + (15 + _vm.width*5.85) + 'rem')},[_c('div',{staticClass:"smallHead"})])]),_c('div',{staticClass:"bigHead"})])}
var staticRenderFns = []

export { render, staticRenderFns }